<div class="row mt-4 mb-3">
  <div class="col">
    <mat-label
      [innerHTML]="text ?? '' | placeholderHighlight : editor ?? false"
    ></mat-label>
  </div>
</div>
